import { Button } from '../ui/button'
import { Switch } from '../ui/switch'
// @ts-strict-ignore
import React, { Fragment } from 'react'
import { Icon } from '@blueprintjs/core'
import { Menu, MenuItem } from '../ui/menu'
import { MyHTMLTable } from '../../packages/blueprint-components/src/HTMLTable'
import classNames from 'classnames'
import PromotionRuleI = Models.PromotionRuleI
import { EllipsisMenu } from '../../icons/icons'
import { Column } from '../../types/table'
import { useSetRecoilState } from 'recoil'

import { activeRuleAtom } from './promotion_state'

interface PromotionRulesTableProps {
    addRule: any // @todo type
    allRulesSelected: any // @todo type
    selectAllRules: any // @todo type
    setRules: any // @todo type
    screenshotMode: boolean // @todo type
    handleAddRule: any // @todo type
    removeRule: any // @todo type
    rules: any // @todo type
}

export const PromotionRulesTable = ({
    addRule,
    allRulesSelected,
    selectAllRules,
    setRules,
    screenshotMode,
    handleAddRule,
    removeRule,
    rules,
}: PromotionRulesTableProps) => {
    const setActiveRuleItem = useSetRecoilState(activeRuleAtom)

    const columns: Column<PromotionRuleI, {}>[] = [
        {
            key: 'name',
            // @ts-ignore // @todo remove
            title: () => (
                <div className="flex flex-col">
                    Name
                    <Switch
                        className="mr-1 mb-0"
                        checked={allRulesSelected}
                        onChange={(e) => {
                            selectAllRules(e.currentTarget.checked)
                        }}
                    />
                </div>
            ),
            cell: (row) => (
                <div className="flex items-center">
                    <Switch
                        className="mr-1 mb-0"
                        checked={row.enabled}
                        onChange={(e) => {
                            const isChecked = e.currentTarget.checked

                            setRules((rules) =>
                                rules.map((r) =>
                                    (row.id && row.id === r.id) || (row.uuid && row.uuid === r.uuid)
                                        ? { ...r, enabled: isChecked }
                                        : r,
                                ),
                            )
                        }}
                    />
                    <div
                        className={classNames('fake-link', { blur: screenshotMode })}
                        onClick={() => handleAddRule(row)}
                    >
                        {row.name}
                    </div>
                </div>
            ),
        },
        {
            key: '',
            title: 'Ad Groups in Use',
            cell: (row) =>
                (row?.rule_items || []).filter((i) => {
                    return (
                        i.use_search_terms ||
                        i.promotion_broad ||
                        i.promotion_phrase ||
                        i.promotion_exact ||
                        i.promotion_products ||
                        i.negation_exact ||
                        i.negation_phrase ||
                        i.negation_products
                    )
                }).length,
        },
        {
            key: ' ',
            title: 'Condition',
            cell: (row) => <ConditionPreview rule={row} />,
        },
        {
            key: ' ',
            title: 'Bid Adjustment',
            cell: (row) => {
                if (row.bid_increase_amount) {
                    const positive = row.bid_increase_amount > 0
                    return `${positive ? 'Increase' : 'Decrease'} bid by ${window.marketplace.currency_symbol}${row.bid_increase_amount}`
                } else if (row.bid_increase_percent) {
                    const positive = row.bid_increase_percent > 0
                    return `${positive ? 'Increase' : 'Decrease'} bid by ${row.bid_increase_percent}%`
                } else {
                    return 'None'
                }
            },
        },
        {
            key: ' ',
            cell: (row) => (
                <EllipsisMenu
                    content={
                        <Menu>
                            <MenuItem
                                key={`remove-item-${row.id}`}
                                text="Remove Rule"
                                onClick={() => removeRule(row)}
                            />
                        </Menu>
                    }
                />
            ),
        },
    ]

    return (
        <Fragment>
            <div className="px-4 pt-4 pb-4 flex justify-between items-center">
                <div className="font-normal text-lg">Rules</div>
                <Button
                    text="Add rule"
                    icon={<Icon icon="plus" color="#3391FF" />}
                    outlined
                    onClick={addRule}
                />
            </div>
            <MyHTMLTable
                disableDefaultHtmlTableWrapperStyle={false}
                htmlTableWrapperClassname={'table-full-page-height'}
                className="mj-table"
                paginationClassname="mx-4 mb-4"
                columns={columns}
                items={rules}
                canSelect={false}
                onSelectChange={null}
                selectKey={null}
                stickyHeader
                stickyFooter
            />
        </Fragment>
    )
}

const ConditionPreview = ({ rule }: { rule: PromotionRuleI }) => {
    const ok = (v: string | number | null) => v !== null && v !== ''
    const line = (title: string, base: string) => {
        const value = rule[base + '_value']
        const operator = rule[base + '_operator']
        if (ok(value)) {
            return (
                <li>
                    {title} {operator} {value}
                </li>
            )
        } else {
            return null
        }
    }

    return (
        <ul>
            {ok(rule.lookback_days) ? (
                <li>Over the last {rule.lookback_days} days</li>
            ) : (
                <li>Lifetime</li>
            )}
            {line('Orders', 'orders')}
            {line('Adj. Orders', 'adjusted_orders')}
            {line('Spend', 'spend')}
            {line('ACoS', 'acos')}
            {line('Blended ACoS', 'blended_acos')}
            {line('Click', 'clicks')}
            {line('Pages Read', 'adjusted_pages_read')}
            {line('Adj. Est. Royalties', 'adjusted_estimated_royalties')}
            {line('Blended Profit', 'blended_profit')}
        </ul>
    )
}
